<template>
  <span>
    <el-link @click="open" type="primary" :underline="underline" :class="fs">
      {{label}}
    </el-link>
    <el-link v-if="openNewTab" :href="calculatedPath" target="_blank" type="primary" :underline="false" class="no-print">
      <i class="mdi mdi-launch ml-10"></i>
    </el-link>
  </span>
</template>
<script>
export default {
	name: 'Portaus-link',
  props: {
    path : String,
    id : Number,
    label : String,
    query: {
      type: Object,
      default() {
        return null;
      }
    },
    underline : {
      type : Boolean,
      default : false
    },
    primary : {
      type : String,
      default : 'primary'
    },
    fs : {
      type : String,
      default : 'fs-14'
    },
    openNewTab : {
      type : Boolean,
      default : true
    },
    type : {
      type : String
    }
  },
	data() {
		return {
		}
	},
  computed: {
    basePath(){
      if (this.id == null) return null;
      let type  = this.type;
      if(type!= null ){
        if (type === 'CREDIT_NOTE') {
          type = 'credit-notes'
        }
        return"/"+type+"/".concat(this.id.toString());
      }
      return this.path.concat(this.id.toString());
    },
    calculatedPath(){
      if (this.basePath == null) return null;
      if (this.query == null || Object.keys(this.query).length === 0) {
        return this.basePath;
      }

      const searchParams = new URLSearchParams();
      Object.entries(this.query).forEach(([key, value]) => {
        if (value != null) {
          searchParams.set(key, value);
        }
      });

      const queryString = searchParams.toString();
      return queryString === '' ? this.basePath : `${this.basePath}?${queryString}`;
    }
  },
	methods: {
    open(){
      if (this.basePath == null) {
        return;
      }

      if (this.query == null || Object.keys(this.query).length === 0) {
        this.$router.push(this.basePath);
        return;
      }

      this.$router.push({ path: this.basePath, query: this.query });
    }
  },
  mounted() {

  }
}
</script>
<style>
</style>
